import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

import * as Yup from 'yup';
import { useFormik } from 'formik';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewReportingType, checkReportingTypeExists, updateReportingType } from '../../../../../slices/reportingType/thunk';
import { setRequireCloseModal } from '../../../../../slices/reportingType/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const ReportingTypeForm = ({
	dataReportingType,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorReportingType = createSelector(
		state => state.ReportingType,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorReportingType);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataReportingType?.name || '',
			disable: dataReportingType?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Tipo de Reportabilidad ya existe', async function (value) {
					if (value && (!isEdit || value !== dataReportingType?.name)) {
						const result = await dispatch(checkReportingTypeExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Tipo de Reportabilidad ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const reportingTypeData = {
				...values,
				...(isEdit && { _id: dataReportingType._id }),
			};

			if (isEdit) {
				await dispatch(updateReportingType(reportingTypeData));
			} else {
				await dispatch(addNewReportingType(reportingTypeData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre del Tipo de Reportabilidad'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading || isAdding || isUpdating}
					>
						{isLoading || isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Crear'} Tipo de Reportabilidad
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ReportingTypeForm;
